/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ObservationstypesObservationType from './ObservationstypesObservationType';

/**
 * The ObservationsTypesBody model module.
 * @module model/ObservationsTypesBody
 * @version v0.3
 */
export default class ObservationsTypesBody {
  /**
   * Constructs a new <code>ObservationsTypesBody</code>.
   * @alias module:model/ObservationsTypesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ObservationsTypesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ObservationsTypesBody} obj Optional instance to populate.
   * @return {module:model/ObservationsTypesBody} The populated <code>ObservationsTypesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ObservationsTypesBody();
      if (data.hasOwnProperty('observation_type'))
        obj.observationType = ObservationstypesObservationType.constructFromObject(data['observation_type']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ObservationstypesObservationType} observationType
 */
ObservationsTypesBody.prototype.observationType = undefined;

